import AttributesTable from './VoucherTable';

export default AttributesTable;



// WEBPACK FOOTER //
// ./src/scenes/Vouchers/index.ts